import request from '../utils/request';

//登录
export function login(data) {
    return request({
        url: 'home/login/index',
        method: 'post',
        data: data,
    });
}

